import { role, utils } from "./globalVariables";
import { getPropInSubLevelRole, safetyDecodeJWT } from "./globalFunctions";

const canAccessResult = (stateArrayRole, stateSubLevel) => {
    return stateArrayRole.includes(getPropInSubLevelRole(safetyDecodeJWT(stateSubLevel, 'syswebapp', 'syswebappsl'), 'slugSubLevel', '')) ? true : false;
}

export const arrayStepsCanBatalNota = [
    utils.projectProcess.nota.value,
    utils.projectProcess.antrian.value,
    utils.projectProcess.pengerjaan.value,
]

export const arrayStepsCanAccessTandaTerima = [
    utils.projectProcess.nota.value,
    utils.projectProcess.antrian.value,
    utils.projectProcess.pengerjaan.value,
    utils.projectProcess.qc.value,
    utils.projectProcess.selesai.value,
    utils.projectProcess.sudah_diambil.value,
    utils.projectProcess.dibatalkan.value,
]

export const arrayStepsCanAccessInvoice = [
    utils.projectProcess.pengerjaan.value,
    utils.projectProcess.qc.value,
    utils.projectProcess.selesai.value,
    utils.projectProcess.sudah_diambil.value,
    utils.projectProcess.dibatalkan.value,
]

export const arrayStepsCanAccessBuktiBayar = [
    utils.projectProcess.selesai.value,
    utils.projectProcess.sudah_diambil.value,
]

export const arrayStepsCanBeAccessedByTeknisiPopUpPengecekan = [
    utils.projectProcess.antrian.value,
    utils.projectProcess.pengerjaan.value,
    utils.projectProcess.qc.value,
    utils.projectProcess.selesai.value,
    utils.projectProcess.sudah_diambil.value,
    utils.projectProcess.dibatalkan.value,
]

export const arrayStepsCanBeAccessedByTeknisiQuickSearch = [
    utils.projectProcess.antrian.value,
    utils.projectProcess.pengerjaan.value,
    utils.projectProcess.qc.value,
    utils.projectProcess.selesai.value,
    utils.projectProcess.sudah_diambil.value,
    utils.projectProcess.dibatalkan.value,
]

// Can see customer's phone number
export const canAccessSeeCustomersPhoneNumber = ({ stateObject }) => {
    const arrayCanAccessRole = [
        role.owner.subLevel.owner.slugSubLevel,
        // role.admin.subLevel.admin_kepala.slugSubLevel,
        role.admin.subLevel.admin_staf.slugSubLevel,
    ]

    return canAccessResult(arrayCanAccessRole, stateObject.subLevel);
}

// Can modify step nota
export const canAccessModifyStepNota = ({ stateObject }) => {
    const arrayCanAccessRole = [
        role.owner.subLevel.owner.slugSubLevel,
        // role.admin.subLevel.admin_kepala.slugSubLevel,
        role.admin.subLevel.admin_staf.slugSubLevel,
    ]

    return canAccessResult(arrayCanAccessRole, stateObject.subLevel);
}

export const canAccessUserBatalNota = ({ stateObject }) => {
    const arrayCanAccessRole = [
        role.owner.subLevel.owner.slugSubLevel,
        // role.admin.subLevel.admin_kepala.slugSubLevel,
        // role.admin.subLevel.admin_staf.slugSubLevel,
    ]

    return canAccessResult(arrayCanAccessRole, stateObject.subLevel);
}

export const canAccessStepBatalNota = ({ stateActualStep }) => {
    return arrayStepsCanBatalNota.includes(stateActualStep) ? true : false;
}

// Can access tanda terima
export const canAccessTandaTerima = ({ stateObject }) => {
    const arrayCanAccessRole = [
        role.owner.subLevel.owner.slugSubLevel,
        // role.admin.subLevel.admin_kepala.slugSubLevel,
        role.admin.subLevel.admin_staf.slugSubLevel,
    ]

    return canAccessResult(arrayCanAccessRole, stateObject.subLevel);
}

// Can access invoice dan bukti bayar
export const canAccessInvoiceDanBuktiBayar = ({ stateObject }) => {
    const arrayCanAccessRole = [
        role.owner.subLevel.owner.slugSubLevel,
        // role.admin.subLevel.admin_kepala.slugSubLevel,
        role.admin.subLevel.admin_staf.slugSubLevel,
    ]

    return canAccessResult(arrayCanAccessRole, stateObject.subLevel);
}

// Steps can access tanda terima
export const stepsCanAccessTandaTerima = ({ stateActualStep }) => {
    return arrayStepsCanAccessTandaTerima.includes(stateActualStep) ? true : false;
}

// Steps can access invoice
export const stepsCanAccessInvoice = ({ stateActualStep }) => {
    return arrayStepsCanAccessInvoice.includes(stateActualStep) ? true : false;
}

// Steps can access bukti bayar
export const stepsCanAccessBuktiBayar = ({ stateActualStep }) => {
    return arrayStepsCanAccessBuktiBayar.includes(stateActualStep) ? true : false;
}

export const canAccessModifyStepNota_Type2 = ({ stateObject }) => {
    const arrayCanAccessRole = [
        role.owner.subLevel.owner.slugSubLevel,
        role.admin.subLevel.admin_staf.slugSubLevel
    ]

    return canAccessResult(arrayCanAccessRole, stateObject.subLevel);
}

export const canAccessModifyRatingProjectTeknisi = ({ stateObject }) => {
    const arrayCanAccessRole = [
        role.owner.subLevel.owner.slugSubLevel,
    ]

    return canAccessResult(arrayCanAccessRole, stateObject.subLevel);
}

export const canAccessModifyModulQC = ({ stateObject }) => {
    const arrayCanAccessRole = [
        role.owner.subLevel.owner.slugSubLevel,
        role.teknisi.subLevel.teknisi_kepala.slugSubLevel,
    ]

    return canAccessResult(arrayCanAccessRole, stateObject.subLevel);
}

export const canAccessSeeModulQC = ({ stateObject }) => {
    const arrayCanAccessRole = [
        role.owner.subLevel.owner.slugSubLevel,
        role.teknisi.subLevel.teknisi_kepala.slugSubLevel,
        // role.teknisi.subLevel.teknisi_staf.slugSubLevel,
    ]

    return canAccessResult(arrayCanAccessRole, stateObject.subLevel);
}

export const canAccessApprovalQC = ({ stateObject }) => {
    const arrayCanAccessRole = [
        role.owner.subLevel.owner.slugSubLevel,
        role.teknisi.subLevel.teknisi_kepala.slugSubLevel,
    ]

    return canAccessResult(arrayCanAccessRole, stateObject.subLevel);
}

// Can modify modul pembayaran
export const canAccessModifyModulPembayaran = ({ stateObject }) => {
    const arrayCanAccessRole = [
        role.owner.subLevel.owner.slugSubLevel,
        // role.admin.subLevel.admin_kepala.slugSubLevel,
        role.admin.subLevel.admin_staf.slugSubLevel,
    ]

    return canAccessResult(arrayCanAccessRole, stateObject.subLevel);
}

export const canAccessModifyPengerjaan = ({ stateObject }) => {
    const arrayCanAccessRole = [
        role.owner.subLevel.owner.slugSubLevel,
        role.teknisi.subLevel.teknisi_kepala.slugSubLevel,
        role.teknisi.subLevel.teknisi_staf.slugSubLevel,
    ]

    return canAccessResult(arrayCanAccessRole, stateObject.subLevel);
}

export const stepsCanBeAccessedByTeknisiPopUpPengecekan = ({ stateStep }) => {
    return arrayStepsCanBeAccessedByTeknisiPopUpPengecekan.includes(stateStep) ? true : false;
}

export const stepsCanBeAccessedByTeknisiQuickSearch = ({ stateStep }) => {
    return arrayStepsCanBeAccessedByTeknisiQuickSearch.includes(stateStep) ? true : false;
}

export const usersCanAccessNotification = ({ stateObject }) => {
    const arrayCanAccessRole = [
        role.owner.subLevel.owner.slugSubLevel,
    ]

    return canAccessResult(arrayCanAccessRole, stateObject.subLevel);
}

export const usersCanAccessReminderMaintenance = ({ stateObject }) => {
    const arrayCanAccessRole = [
        role.owner.subLevel.owner.slugSubLevel,
        // role.admin.subLevel.admin_kepala.slugSubLevel,
        role.admin.subLevel.admin_staf.slugSubLevel
    ]

    return canAccessResult(arrayCanAccessRole, stateObject.subLevel);
}